// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__9dcML","header":"styles_header__-CDhO","body":"styles_body__YUV4F","scroll":"styles_scroll__vpn+-","footer":"styles_footer__0YuwT"};